import {
  EllipsisOutlined,
  InstagramOutlined,
  MailOutlined,
  MinusOutlined,
  PhoneOutlined,
  PushpinOutlined,
  ShareAltOutlined,
  ShopOutlined,
  SoundOutlined,
  TeamOutlined
} from "@ant-design/icons"
import React, { type ReactNode } from "react"

import AngiIcon from "../../../Images/lead-sources/angi.svg?react"
import FacebookIcon from "../../../Images/lead-sources/facebook.svg?react"
import GoogleIcon from "../../../Images/lead-sources/google.svg?react"
import HouzzIcon from "../../../Images/lead-sources/houzz.svg?react"
import PhoneIcon from "../../../Images/lead-sources/phone.svg?react"
import ReferralIcon from "../../../Images/lead-sources/referral.svg?react"
import YelpIcon from "../../../Images/lead-sources/yelp.svg?react"

const BRAND_ICON_SIZE = 16

/**
 * Keyed by `Project.LeadSource` value, not by label — labels are display text
 * and the API is free to reword them. `crm.Lead` inherits `source` from
 * `core.Project`, so the brand values below are the ones actually served; the
 * six generic categories this map used to assume belong to `Customer`.
 *
 * The brand marks come from the client's icon pack and keep their own colours,
 * so they are vendored as SVG rather than redrawn as `currentColor` glyphs.
 * Sources the pack has no mark for fall back to an icon of their own kind.
 */
const LEAD_SOURCE_ICONS: Record<string, ReactNode> = {
  referral: <ReferralIcon width={BRAND_ICON_SIZE} height={BRAND_ICON_SIZE} />,
  yelp: <YelpIcon width={BRAND_ICON_SIZE} height={BRAND_ICON_SIZE} />,
  google_ads: <GoogleIcon width={BRAND_ICON_SIZE} height={BRAND_ICON_SIZE} />,
  angi: <AngiIcon width={BRAND_ICON_SIZE} height={BRAND_ICON_SIZE} />,
  houzz: <HouzzIcon width={BRAND_ICON_SIZE} height={BRAND_ICON_SIZE} />,
  facebook: <FacebookIcon width={BRAND_ICON_SIZE} height={BRAND_ICON_SIZE} />,
  direct_call: <PhoneIcon width={BRAND_ICON_SIZE} height={BRAND_ICON_SIZE} />,

  home_advisor: <ShopOutlined />,
  thumbtack: <PushpinOutlined />,
  instagram: <InstagramOutlined />,
  social_media: <ShareAltOutlined />,
  paid_advertisement: <SoundOutlined />,
  trade_show: <TeamOutlined />,
  direct_mail: <MailOutlined />,
  telemarketing: <PhoneOutlined />,
  other: <EllipsisOutlined />,
  none: <MinusOutlined />
}

const FALLBACK_SOURCE_ICON = <EllipsisOutlined />

const leadSourceIcon = (value?: string | null): ReactNode =>
  (value && LEAD_SOURCE_ICONS[value]) || FALLBACK_SOURCE_ICON

export { LEAD_SOURCE_ICONS, leadSourceIcon }
